





export default {
  name: 'floating-image'

  props: ['image', 'x', 'y', 'width', 'opacity']

  computed:
    styles: -> return {
      left: @x+'%'
      top: @y+'%'
      width: @width+'%'
      opacity: @opacity
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/generic/FloatingImage.vue